export enum IslandType {
  Class,
  Home,
  Playground,
  PublicRoleplay,
}
